import { useApi } from '@/api';
import { type RootState } from '@/store';
import type { GetAffiliateKpiBonusesAvailableTypesResponse } from '@/types/openapi-ts';
import type { TypedStoreModule } from '@/types/vuex';
import type { ActionContext } from 'vuex';

export interface AffiliateState {
  kpiBonusTypes: GetAffiliateKpiBonusesAvailableTypesResponse['payload']['available_types'],
}

const actions = {
  async kpiBonusTypes({ commit }: ActionContext<AffiliateState, RootState>) {
    const api = useApi();

    const { data: { payload } } = await api.getAffiliateKpiBonusTypes();
    commit('kpiBonusTypes', payload);
  },
};

const mutations = {
  kpiBonusTypes(state: AffiliateState, payload: GetAffiliateKpiBonusesAvailableTypesResponse['payload']) {
    state.kpiBonusTypes = payload.available_types;
  },
};

const state = {
  kpiBonusTypes: [],
};

const storeModule = {
  state,
  actions,
  mutations,
  namespaced: true,
};


export type AffiliateModule = TypedStoreModule<'affiliate', typeof storeModule>;

export default storeModule;